import { IconButton, Image, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const HorizontalSkuCard = styled.div`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 8px;
  position: relative;
  width: 344px;

  ${IconButton.S.IconButton} {
    position: absolute;
    right: -6px;
    top: -6px;
  }
`;

const FacadeImage = styled(Image)`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  height: 80px;
  min-width: 72px;
  width: 72px;
`;

const CardBody = styled.div`
  width: 100%;
`;

const CardRow = styled.div`
  position: static;
  top: 36px;
`;

const CardName = styled(Typography)`
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 200px;

  &:hover {
    overflow: visible;
    white-space: normal;
  }
`;

export { CardBody, CardName, CardRow, FacadeImage, HorizontalSkuCard };
